(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-router-dom', 'emotion', '../../styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-router-dom'), require('emotion'), require('../../styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.reactRouterDom, global.emotion, global.styles);
    global.VerticalNavLink = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _reactRouterDom, _emotion, _styles) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    text-decoration: none;\n    color: ', ';\n    &:hover {\n      color: ', ';\n      text-decoration: none;\n    }\n  '], ['\n    text-decoration: none;\n    color: ', ';\n    &:hover {\n      color: ', ';\n      text-decoration: none;\n    }\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: block;\n    width: 100%;\n    padding: 1rem 1rem 1rem 0.5rem;\n\n    @media screen and (min-width: 1920px) {\n      padding: 1rem;\n    }\n  '], ['\n    display: block;\n    width: 100%;\n    padding: 1rem 1rem 1rem 0.5rem;\n\n    @media screen and (min-width: 1920px) {\n      padding: 1rem;\n    }\n  ']);

  var VerticalNavLink = function VerticalNavLink(_ref) {
    var path = _ref.path,
        children = _ref.children,
        className = _ref.className;
    return React.createElement(
      _reactRouterDom.Link,
      { to: path, className: (0, _emotion.cx)(classNames.aReset, classNames.link, className) },
      children
    );
  };

  VerticalNavLink.defaultProps = {
    className: ''
  };

  var classNames = {
    aReset: (0, _emotion.css)(_templateObject, _styles.colors.prussian, _styles.colors.prussian),
    link: (0, _emotion.css)(_templateObject2)
  };

  exports.default = VerticalNavLink;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/VerticalNav/VerticalNavLink.js
// module id = 2033
// module chunks = 1